/**
 * Observabilidade leve no frontend (T11).
 * Sem tokens/PII/clínica. Útil para correlacionar fallback legado.
 */

export type MemedFrontendFallbackReason =
  | 'feature_disabled'
  | 'session_error'
  | 'script_load_error'
  | 'widget_error'
  | 'profile_incomplete'
  | 'provider_unavailable'
  | 'auth'
  | 'forbidden'
  | 'timeout'
  | 'renewal_unavailable';

export function logMemedFrontendEvent(payload: {
  event: 'memed_fallback' | 'memed_op_success' | 'memed_op_failure';
  operation?: string;
  reason?: MemedFrontendFallbackReason;
  code?: string;
  durationMs?: number;
}): void {
  const line = JSON.stringify({
    provider: 'MEMED',
    ...payload,
  });
  // Sempre estruturado; nunca inclui token.
  // Falhas/fallback: warn. Sucesso: silencioso no browser (métricas via backend).
  if (payload.event === 'memed_fallback' || payload.event === 'memed_op_failure') {
    console.warn(line);
  }
}

/** Timeout de UX para não ficar em loading infinito (ms). */
export const MEMED_UX_TIMEOUT_MS = 45_000;

export function withUxTimeout<T>(
  promise: Promise<T>,
  timeoutMs = MEMED_UX_TIMEOUT_MS,
  message = 'A operação Memed excedeu o tempo limite. Tente novamente.',
): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    const timer = setTimeout(() => {
      reject(
        Object.assign(new Error(message), {
          code: 'MEMED_UX_TIMEOUT',
          kind: 'technical',
          allowLegacyFallback: true,
        }),
      );
    }, timeoutMs);

    promise
      .then((value) => {
        clearTimeout(timer);
        resolve(value);
      })
      .catch((error) => {
        clearTimeout(timer);
        reject(error);
      });
  });
}
